/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { CanvasCellPresenterBase } from "./CanvasCellPresenterBase";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var CanvasRowSeparatorCellPresenter = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CanvasRowSeparatorCellPresenter, _super);
    function CanvasRowSeparatorCellPresenter(a) {
        return _super.call(this, a) || this;
    }
    Object.defineProperty(CanvasRowSeparatorCellPresenter.prototype, "d", {
        get: function () {
            return this.a;
        },
        enumerable: true,
        configurable: true
    });
    CanvasRowSeparatorCellPresenter.$t = markType(CanvasRowSeparatorCellPresenter, 'CanvasRowSeparatorCellPresenter', CanvasCellPresenterBase.$);
    return CanvasRowSeparatorCellPresenter;
}(CanvasCellPresenterBase));
export { CanvasRowSeparatorCellPresenter };
//# sourceMappingURL=CanvasRowSeparatorCellPresenter.js.map
